import { isParentUser } from '@/features/create-post/composerModeAccess';
import { readPaymentOptionAvailableOnWebFromRawUser } from '@/features/payments/readPaymentOptionAvailableOnWeb';
import { useAuthStore, type AuthUser, type RawAuthUser } from '@/store/authStore';

export function canAccessPayments(
  rawUser: RawAuthUser | null | undefined,
  user: AuthUser | null | undefined,
): boolean {
  return isParentUser(rawUser, user) && readPaymentOptionAvailableOnWebFromRawUser(rawUser);
}

export function useCanAccessPayments(): boolean {
  const rawUser = useAuthStore((state) => state.rawUser);
  const user = useAuthStore((state) => state.user);
  return canAccessPayments(rawUser, user);
}
